module.exports = __webpack_public_path__ + "img/kosmos-dinning-room.e7c70481.jpg";